export default "__VITE_ASSET__af731725__"